// Управление темой: light / dark / auto (следует за системными настройками).
// Сохраняется в localStorage. При auto слушает prefers-color-scheme в реальном времени.

export type ThemeMode = 'light' | 'dark' | 'auto'

const STORAGE_KEY = 'crm:theme'
const DARK_CLASS = 'dark'

const mediaQuery =
  typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null

function readStored(): ThemeMode {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'light' || v === 'dark' || v === 'auto') return v
  } catch {
    /* SSR / заблокированный localStorage */
  }
  return 'auto'
}

function resolveEffective(mode: ThemeMode): 'light' | 'dark' {
  if (mode === 'auto') return mediaQuery?.matches ? 'dark' : 'light'
  return mode
}

function applyToDom(effective: 'light' | 'dark'): void {
  const root = document.documentElement
  if (effective === 'dark') root.classList.add(DARK_CLASS)
  else root.classList.remove(DARK_CLASS)
  root.dataset.theme = effective
}

export function getTheme(): ThemeMode {
  return readStored()
}

export function setTheme(mode: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    /* noop */
  }
  applyToDom(resolveEffective(mode))
}

export function initTheme(): void {
  const mode = readStored()
  applyToDom(resolveEffective(mode))

  // Следим за сменой системной темы — обновляем только если режим auto.
  mediaQuery?.addEventListener('change', () => {
    if (readStored() === 'auto') {
      applyToDom(resolveEffective('auto'))
    }
  })
}
